import { Outlet } from 'react-router-dom';
import TopBar from './TopBar.jsx';
import TodayStrip from './TodayStrip.jsx';
import ReadStoreNotice from './ReadStoreNotice.jsx';
import BottomTabBar from './BottomTabBar.jsx';
import SideNav from './SideNav.jsx';
import RequireAuth from './RequireAuth.jsx';
import { Toaster } from '@/components/ui/toaster.jsx';
import SearchPalette from '@/components/shared/SearchPalette.jsx';
import V3SearchPalette from '@/components/v3/V3SearchPalette.jsx';
import { usePeekStore } from '@/stores/peek-store.js';
import { useShellStore } from '@/stores/shell-store.js';
import ContactPeekSheet from '@/components/sheets/ContactPeekSheet.jsx';
import AircraftPeekSheet from '@/components/sheets/AircraftPeekSheet.jsx';
import CarrierPeekSheet from '@/components/sheets/CarrierPeekSheet.jsx';

// The TRACON shell (Task I). One atmosphere across every view:
//   topbar (full) / Today strip (full) / [left-nav | main | right-rail].
// Nav collapses (shell-store); the right rail is a slot a deal/account
// workspace fills (I.2/I.3) and list views leave empty. On phone the grid
// folds to a single column with the bottom tab bar (TRACON-DESIGN-SYSTEM.md).
export default function AppShell() {
  const peek = usePeekStore((s) => s.peek);
  const closePeek = usePeekStore((s) => s.closePeek);
  const rail = useShellStore((s) => s.rail);

  return (
    <RequireAuth>
      <div className="flex h-[100dvh] flex-col overflow-hidden bg-bg text-text">
        <TopBar />
        <TodayStrip />
        <ReadStoreNotice />

        <div className="flex min-h-0 flex-1">
          <SideNav />

          <main className="min-w-0 flex-1 overflow-y-auto pb-[calc(56px+env(safe-area-inset-bottom))] md:pb-0">
            <Outlet />
          </main>

          {rail ? (
            <aside className="hidden w-rail-w shrink-0 overflow-y-auto border-l border-border bg-surface lg:block">
              {rail}
            </aside>
          ) : null}
        </div>

        <BottomTabBar />
        <Toaster />
        <SearchPalette />
        <V3SearchPalette />
        {peek?.kind === 'contact' && (
          <ContactPeekSheet id={peek.id} onClose={closePeek} />
        )}
        {peek?.kind === 'aircraft' && (
          <AircraftPeekSheet id={peek.id} onClose={closePeek} />
        )}
        {peek?.kind === 'carrier' && (
          <CarrierPeekSheet id={peek.id} onClose={closePeek} />
        )}
      </div>
    </RequireAuth>
  );
}
